import { Base } from 'src/api/Base'

export class DealerOverviewAPI extends Base {
  static get entity() {
    return 'dealer-overview'
  }

  static async getData() {
    const params = {
      ...this.datepicker,
    }

    const { data } = await this.request().get(`/${this.entity}/data`, {
      params,
    })

    return data
  }

  static async restoreDefaults({ type }) {
    const params = {
      ...this.datepicker,
    }

    const body = {
      type,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/defaults`, body, {
      params,
    })

    return data
  }

  static async add({ type, kpi }) {
    const params = {
      ...this.datepicker,
    }

    const body = {
      type,
      kpi,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/add`, body, {
      params,
    })

    return data
  }

  static async remove({ type, kpi }) {
    const params = {
      ...this.datepicker,
    }

    const body = {
      type,
      kpi,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/remove`, body, {
      params,
    })

    return data
  }

  static async export({ metrics, dealerships, comparison, format, percentages = false, orderby }) {
    const options = this.normalizeOptions({
      comparison,
      percentages: Number(percentages),
      orderby,
    })
    const params = {
      ...this.datepicker,
      metrics,
      format,
      dealerships: dealerships.join(','),
      ...options,
    }

    const { data } = await this.request({
      shouldCancelOnGet: false,
      shouldCancelOnRoute: false,
    }).get(`/${this.entity}/export`, {
      params,
    })

    return data
  }

  static async setTag({ type, kpi, tag }) {
    const params = {
      ...this.datepicker,
      dealerShipId: 0,
    }
    const { data } = await this.request({
      shouldCancelOnGet: false,
      shouldCancelOnRoute: false,
    }).post(
      `/${this.entity}/set-tag`,
      { type, kpi, tag },
      {
        params,
      }
    )

    return data
  }

  static async move({ type, kpi, position }) {
    const params = {
      ...this.datepicker,
    }

    const body = {
      type,
      kpi,
      position,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/move`, body, {
      params,
    })

    return data
  }
}
